<template>
  <transition name="fade">
    <section class="cursor-pointer" @click="clickOutside">
      <article
        class="cursor-auto bg-white pt-4 px-4 pb-24 w-full max-w-6xl overflow-y-auto"
      >
        <div class="flex justify-end text-3xl pt-4 pr-4 pb-8">
          <div
            class="cursor-pointer transition-all duration 200 hover:text-secondary-500"
            @click="hideModal"
          >
            <BaseIcon name="times" />
          </div>
        </div>

        <figure class="mb-12">
          <div class=" flex justify-center">
            <div class="w-64 h-64">
              <img
                class="h-full rounded-full"
                :src="currentSpeaker.image_url"
                :alt="currentSpeaker.full_name"
              />
            </div>
          </div>

          <figcaption class="mt-8">
            <h3 class="font-bold text-4xl">{{ currentSpeaker.full_name }}</h3>
            <p class="text-xl text-main-400">{{ currentSpeaker.position }}</p>
            <p class="text-xl text-main-400">{{ currentSpeaker.company }}</p>

            <div class="px-4 mt-8 py-8 border-t border-b text-left sm:px-12">
              <p>{{ currentSpeaker.description }}</p>
            </div>
          </figcaption>
        </figure>

        <div v-if="currentSpeaker.videos.length">
          <h4 class="font-bold text-xl">
            Sesiones de {{ currentSpeaker.full_name }}
          </h4>
          <div class=" md:flex md:flex-wrap md:flex-shrink md:justify-center">
            <VideoListItem
              v-for="video in currentSpeaker.videos"
              :key="video.pk"
              :video="video"
            />
          </div>
        </div>
      </article>
    </section>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import VideoListItem from '@/components/VideoListItem'

export default {
  components: { VideoListItem },

  computed: {
    ...mapState('speakers', ['currentSpeaker']),
  },

  methods: {
    clickOutside(e) {
      if (e.target instanceof HTMLElement && this.$el === e.target) {
        this.hideModal()
      }
    },

    hideModal() {
      this.$store.commit('speakers/setCurrentSpeaker', {})
      this.$store.commit('speakers/setShowSpeakerModal', false)
    },
  },
}
</script>

<style scoped>
section {
  @apply fixed w-full h-screen inset-0 flex items-center justify-center z-10 rounded px-4;
  background-color: rgba(0, 0, 0, 0.5);
}

article {
  max-height: 90%;
}
</style>
